import { Api, ApiResponse } from './api';
import { Token } from './token';

export class BulkApi<T> {
    constructor(
        public readonly url: string,
        public readonly resource: string,
        private readonly api: typeof Api,
    ) {}

    /**
     * bulk inserts
     */
    async insert(data: Record<string, unknown>): Promise<ApiResponse|Response> {
        // does not use api.post() because we need the bulk insert endpoint
        const token = await this.api.request_token().then((t: Token) => t.token);
        let headers = new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        });
        headers = await this.api.add_csrf_header(headers, 'POST');

        return fetch(`${this.url}/api/bulk/${this.resource}`, {
            body: JSON.stringify(data),
            method: 'post',
            headers,
        });
    }

    /**
     * bulk updates
     * @param data - array of updates
     */
    async update(data: Record<string, unknown>): Promise<ApiResponse|Response> {
        // does not use api.put() because we need the bulk update endpoint
        const token = await this.api.request_token().then((t: Token) => t.token);
        let headers = new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        });
        headers = await this.api.add_csrf_header(headers, 'PUT');

        return fetch(`${this.url}/api/bulk/${this.resource}`, {
            body: JSON.stringify(data),
            method: 'put',
            headers,
        });
    }

    /**
     * bulk deletion
     */
    async delete(conditionField: string, conditionId: number): Promise<ApiResponse|Response> {
        // does not use api.delete() because we need the bulk delete endpoint
        const token = await this.api.request_token().then((t: Token) => t.token);
        let headers = new Headers({
            Authorization: `Bearer ${token}`,
        });
        headers = await this.api.add_csrf_header(headers, 'DELETE');

        return fetch(`${this.url}/api/bulk/${this.resource}/${conditionField}/${conditionId}`, {
            method: 'delete',
            headers,
        });
    }
}
